import React from "react";
import { useSelector } from "react-redux";
import { selectRecurringTransactionHistory } from "../../../../../redux/slices/recurringSummaryHistorySlice";
import { selectIsCms } from "../../../../../redux/slices/configSettingsSlice";
import RecurringSummaryHistoryList from "./RecurringSummaryHistoryList";

/**
 * @param {object} props
 * @param {string} props.dateLabel
 * @param {string} props.statusLabel
 * @param {string} props.transactionIdLabel
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryHistoryList = ({
    dateLabel,
    statusLabel,
    transactionIdLabel,
}) => {
    const transactionHistory = useSelector(selectRecurringTransactionHistory);
    const isCms = useSelector(selectIsCms);

    const handleClick = (e) => {
        if (isCms) {
            e.preventDefault();
        }
    };

    return (
        <RecurringSummaryHistoryList
            dateLabel={dateLabel}
            handleClick={handleClick}
            statusLabel={statusLabel}
            transactionHistory={transactionHistory}
            transactionIdLabel={transactionIdLabel}
        />
    );
};

export default ConnectedRecurringSummaryHistoryList;
